import React from 'react';

import { StudioHome } from '../../../../modules/vendor/studio/components/StudioHome';

const StudioHomePage: React.FC = () => <StudioHome />;

export default StudioHomePage;
